<template>
  <div>
    <h1>Slider 滑块</h1>
    <p class="page-desc">
      滑动输入器，用于在数值区间/自定义区间内进行选择。
    </p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="基础用法" :code="JCYF" desc="基本滑动条。">
          <p>{{ value1 }}</p>
          <k-slider v-model="value1"></k-slider>

          <k-slider v-model="value4" disabled></k-slider>
        </demo-viewer>

        <demo-viewer title="离散值" :code="LSZ" desc="选项可以是离散的">
          <p>{{ value3 }}</p>
          <k-slider v-model="value3" :step="5"></k-slider>
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="范围选择" :code="FWXZ" desc="支持选择某一数值范围">
          <p>{{ value2 }}</p>
          <k-slider v-model="value2" range></k-slider>
        </demo-viewer>

        <demo-viewer title="滑块形状" :code="FXHK" desc="方形滑块。">
          {{ value1 }}
          <k-slider v-model="value1" button="square"></k-slider>

          <p style="margin-top:40px;">{{ value2 }}</p>
          <k-slider v-model="value2" button="square" range></k-slider>
        </demo-viewer>
      </k-col>
    </k-row>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>value</td>
          <td>
            <p>滑块选定的值，可以使用 v-model 双向绑定数据。</p>
            <p>
              普通模式下，数据格式为数字，在双滑块模式下，数据格式为长度是2的数组，且每项都为数字
            </p>
          </td>
          <td>Number | Array</td>
          <td>0</td>
        </tr>
        <tr>
          <td>min</td>
          <td>最小值</td>
          <td>Number</td>
          <td>0</td>
        </tr>
        <tr>
          <td>max</td>
          <td>最大值</td>
          <td>Number</td>
          <td>100</td>
        </tr>
        <tr>
          <td>step</td>
          <td>步长，取值建议能被（max - min）整除</td>
          <td>Number</td>
          <td>1</td>
        </tr>
        <tr>
          <td>disabled</td>
          <td>是否禁用滑块</td>
          <td>Boolean</td>
          <td>false</td>
        </tr>
        <tr>
          <td>button</td>
          <td>定义滑块形状,可选值为circle、square</td>
          <td>String</td>
          <td>circle</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>事件 events</h3>
      </caption>
      <thead>
        <tr>
          <th>事件名</th>
          <th>说明</th>
          <th>返回值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>on-change</td>
          <td>在松开滑动时触发，返回当前的选值，在滑动过程中不会触发</td>
          <td>value</td>
        </tr>
        <tr>
          <td>on-input</td>
          <td>滑动条数据变化时触发，返回当前的选值，在滑动过程中实时触发</td>
          <td>value</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 25,
      value2: [20, 50],
      value3: 25,
      value4: 30,
      JCYF:
        `
  <template>
    <k-slider v-model="value1"></k-slider>
    <k-slider v-model="value4" disabled></k-slider>
  </template>
  <script>
    export default {
      data () {
        return {
          value1: 25
        }  
      }
    }
  </` +
        `script>
    `,
      FWXZ:
        `
  <template>
    <k-slider v-model="value2" range></k-slider>
  </template>
  <script>
    export default {
      data () {
        return {
          value2: [20, 50]
        }  
      }
    }
  </` +
        `script>
    `,
      LSZ:
        `
  <template>
    <k-slider v-model="value3" :step="5"></k-slider>
  </template>
  <script>
    export default {
      data () {
        return {
          value3: 25
        }  
      }
    }
  </` +
        `script>
    `,
      FXHK: `
  <template>
    <k-slider v-model="value1" button="square"></k-slider>
    <k-slider v-model="value2" button="square" range></k-slider>
  </template>
    `
    };
  },
  methods: {}
};
</script>
